import { render, staticRenderFns } from "./TesTab.vue?vue&type=template&id=cf9defd2&"
import script from "./TesTab.vue?vue&type=script&lang=ts&"
export * from "./TesTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports